import { Component, Input } from '@angular/core';

@Component({
  selector: 'un-page',
  templateUrl: 'page.component.html',
  styleUrls: ['page.component.scss'],
  standalone: false,
})
export class PageComponent {
  @Input() public backgroundColor: 'white' | 'transparent' = 'transparent';
}
